import * as excel from "xlsx";

export const readCsvOrExcel = (acceptedFile, setUploadValues, setError) => {
  const reader = new FileReader();

  reader.onabort = () => setError("File reading was aborted");
  reader.onerror = () => setError("File reading has failed");

  if (acceptedFile.name.endsWith(".xlsx")) {
    return parseXlsx(reader, acceptedFile, setUploadValues, setError);
  }
  if (acceptedFile.name.endsWith(".csv")) {
    return parseCsv(reader, acceptedFile, setUploadValues, setError);
  }

  setError("Unsupported file format");
};

const parseCsv = (reader, file, setUploadValues, setError) => {
  reader.onload = (e) => {
    const workbook = excel.read(e.target.result, { type: "binary" });

    const sheetName = workbook.SheetNames[0];

    const sheetToImport = workbook.Sheets[sheetName];

    const csv = excel.utils.sheet_to_json(sheetToImport);

    const didError = { error: false, row: [] };
    const values = csv.map((row) => {
      const stringValue = Object.values(row).join(" ");

      if (stringValue.length > 50) {
        didError.error = true;
        didError.row = [...didError.row, stringValue];
      }

      return stringValue;
    });

    if (didError.error) {
      setError({
        error: true,
        reason: `${didError.row} are over 50 characters long`,
      });
    } else {
      setUploadValues(values);
    }
  };

  reader.readAsBinaryString(file);
};

const parseXlsx = (reader, file, setUploadValues, setError) => {
  reader.onload = (e) => {
    const workbook = excel.read(e.target.result, { type: "binary" });

    const sheetName = workbook.SheetNames[0];

    const sheetToImport = workbook.Sheets[sheetName];

    const csv = excel.utils.sheet_to_json(sheetToImport);

    const didError = { error: false, row: [] };
    const values = csv.map((row) => {
      const stringValue = Object.values(row);

      if (stringValue.length > 50) {
        didError.error = true;
        didError.row = [...didError.row, stringValue];
      }

      return stringValue;
    });

    if (didError.error) {
      setError({
        error: true,
        reason: `${didError.row} are over 50 characters long`,
      });
    } else {
      setUploadValues(values);
    }
  };

  reader.readAsBinaryString(file);
};
